import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { useTranslation } from "react-i18next"

interface DeleteItemDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  itemType: 'organization' | 'workspace' | 'board'
  itemName: string
  onConfirm: () => void
}

export function DeleteItemDialog({
  isOpen,
  onOpenChange,
  itemType,
  itemName,
  onConfirm,
}: DeleteItemDialogProps) {
  const { t } = useTranslation()

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('Delete')} {itemType}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('Are you sure you want to delete')} {itemName}?
            {itemType === 'organization' && t(' This will also delete all workspaces and boards within it.')}
            {itemType === 'workspace' && t(' This will also delete all boards within it.')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('Cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{t('Delete')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}